<template>
    <div v-if="_header" class="text-danger">
        <h5>Whoops! Fehler {{code}} ({{ this._errors.name }})</h5>
        <h3>Fehler beim Laden der Daten</h3>
    </div>

    <p class="lead" style="text-align: center" v-else>
        <span v-if="code === 404">Resource wurde nicht gefunden</span>
        <span v-else-if="code === 403">Keine Berechtigung</span>
        <span v-else-if="code === 401">
          Du scheinst nicht mehr angemeldet zu sein.
          <br>
          <button type="button" @click="refresh" class="btn btn-primary btn-sm">
            Jetzt Neu Einloggen
          </button>
        </span>
        <span v-else-if="code === 500">Interner Serverfehler</span>
        <span v-else-if="_errors.message === 'Network Error'">Kein Internetzugang (Offline?)</span>
        <span v-else v-text="_errors.message" />
    </p>
</template>

<script>
export default {
  props: ['_errors', '_header'],

  computed: {
    code() {
      // eslint-disable-next-line no-underscore-dangle
      const { status = -1 } = this._errors.response;
      return status;
    },
  },

  methods: {
    refresh() {
      window.location.reload(true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/view-stack/components/error.vue